module.exports = __webpack_public_path__ + "img/Chemistry.ec980a27.svg";